import { createSlice } from '@reduxjs/toolkit';
import { RESET_ALL_REDUCERS } from 'actions';

const initialState = {
    loading: false,
    error: null,
    message: null,
    errorMsg: null,
    idmkbaResponse: null,
    idmSessionId: null,
    ssnInfo: {
        isFallbackRequired: false,
    },
};

const kbaSlice = createSlice({
    name: 'kba',
    initialState,
    reducers: {
        requestKba: (state) => {
            state.loading = true;
        },
        updateKba: (_state, action) => ({
            ...action.payload,
            loading: false,
        }),
        // Clear a prior error before a fallback re-fetch. The self-verify refresh
        // updates remainingFallbacks before getKbaQuestions resolves; without
        // clearing the stale error first, useKbaQuiz would re-offer the next
        // fallback on the refresh alone (even when the re-fetch ends up 200).
        // Keep loading true so the page shows the loader and the modal stays shut
        // until a genuinely new error arrives.
        clearKbaError: (state) => {
            state.error = null;
            state.message = null;
            state.errorMsg = null;
            state.loading = true;
        },
        resetKba: () => initialState,
    },
    extraReducers: (builder) => {
        // App-wide reset on session teardown (new token / re-auth).
        builder.addCase(RESET_ALL_REDUCERS, () => initialState);
    },
});

export const { requestKba, updateKba, clearKbaError, resetKba } = kbaSlice.actions;
export default kbaSlice.reducer;
